export const PLANNING_EMPTY_STATE_LINES = [
  'What would you like to plan?',
  'Where should this path take you?',
  'What are we working on?',
  'What’s this path for?',
  'What should we plan first?',
];

const picksByKey = new Map(); // sessionKey -> line string
const PENDING_KEY = '__pending__';

export function getPlanningEmptyStateLine(sessionKey) {
  const key = sessionKey == null ? PENDING_KEY : sessionKey;
  if (picksByKey.has(key)) {
    return picksByKey.get(key);
  }
  const line = PLANNING_EMPTY_STATE_LINES[
    Math.floor(Math.random() * PLANNING_EMPTY_STATE_LINES.length)
  ];
  picksByKey.set(key, line);
  return line;
}

export function bindPendingEmptyStateLine(sessionId) {
  if (!sessionId) return;
  if (picksByKey.has(sessionId)) return;
  if (!picksByKey.has(PENDING_KEY)) return;
  picksByKey.set(sessionId, picksByKey.get(PENDING_KEY));
  picksByKey.delete(PENDING_KEY);
}

export function resetPlanningEmptyStatePicks() {
  picksByKey.clear();
}

export function isPlanningResumePending({
  resumeLoading,
  routeSessionId,
  sessionId,
  justCreatedSessionId,
}) {
  if (resumeLoading) return true;
  if (!routeSessionId) return false;
  if (justCreatedSessionId === routeSessionId) return false;
  return routeSessionId !== sessionId;
}

export function shouldShowPlanningEmptyState({ messages, error, generating, resumeLoading }) {
  return (
    Array.isArray(messages) &&
    messages.length === 0 &&
    !error &&
    !generating &&
    !resumeLoading
  );
}
